module.exports = __webpack_public_path__ + "static/media/guide_desktop_04.1b30312e.svg";